import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Phone, MessageSquare, BarChart3 } from "lucide-react";
import ScreeningDashboard from "@/components/screening/ScreeningDashboard";
import ScreeningDetail from "@/components/screening/ScreeningDetail";

const ScreeningMain = () => {
  const [activeView, setActiveView] = useState<"dashboard" | "analytics">("dashboard");
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Screening Center</h1>
        <div className="flex items-center gap-3">
          <div className="text-sm text-muted-foreground hidden md:block">
            Track and manage candidate screenings with AI insights.
          </div>
          <Tabs value={activeView} onValueChange={(value) => setActiveView(value as typeof activeView)} className="w-fit">
            <TabsList>
              <TabsTrigger value="dashboard" className="flex items-center gap-1">
                <Phone className="h-4 w-4" />
                <span className="hidden md:inline">Dashboard</span>
              </TabsTrigger>
              <TabsTrigger value="analytics" className="flex items-center gap-1">
                <BarChart3 className="h-4 w-4" />
                <span className="hidden md:inline">Analytics</span>
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>
      
      <Tabs value={activeView} onValueChange={(value) => setActiveView(value as typeof activeView)}>
        <TabsContent value="dashboard">
          <ScreeningDashboard />
        </TabsContent>
        
        <TabsContent value="analytics">
          <div className="bg-muted/50 rounded-lg p-8 text-center">
            <BarChart3 className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <h3 className="text-lg font-medium mb-2">Analytics Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              Advanced screening analytics and insights will be available here.
            </p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

const Screening = () => {
  return (
    <Routes>
      <Route path="/" element={<ScreeningMain />} />
      <Route path="/:id" element={<ScreeningDetail />} />
    </Routes>
  );
};

export default Screening;